






































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import '@/compiled-icons/check';
import '@/compiled-icons/error-outline';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import Ajv from 'ajv';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';

@Component({
  name: 'dynamic-document-export-template',
  components: {
    AmetrasTextAreaFieldTemplate
  }
})
export default class DynamicDocumentImportTemplate extends Vue {

  step = 1;
  documentRaw: string = '';
  documentStatus: 'PARSING' | 'PARSED' | 'FAILED' | null = null;
  uploadStatus: 'RUNNING' | 'DONE' | 'FAILED' | null = null;
  documentParsed: DisguiseDto.DynamicDocumentDtoV2 = {
    '@type': 'DynamicDocumentDtoV2'
  };

  parseDocument() {
    this.step = 2;
    this.documentStatus = 'PARSING';
    setTimeout(() => {
      import('@/assets/jsonschema/DisguiseDto.schema.json').then((schema) => {
        try {
          this.documentParsed = JSON.parse(this.documentRaw);
          const validationFunction = new Ajv({
            strict: true,
            allErrors: true
          }).addSchema(schema).compile(schema.definitions['DisguiseDto.DynamicDocumentDtoV2']);
          const valid = validationFunction(this.documentParsed);
          this.documentStatus = valid ? 'PARSED' : 'FAILED';
        } catch (error) {
          this.documentStatus = 'FAILED';
        }
      }, () => {
        this.documentStatus = 'FAILED';
      });
    }, 1000);
  }

  startImport() {
    this.step = 3;
    this.uploadStatus = 'RUNNING';

    HTTP_SERVICE_INSTANCE.getAxios().post('/dynamicdocuments/v0/documents/import', this.documentParsed).then(() => {
      this.uploadStatus = 'DONE';
    }, () => {
      this.uploadStatus = 'FAILED';
    });
  }

  reset() {
    this.documentRaw = '';
    this.documentParsed = {
      '@type': 'DynamicDocumentDtoV2'
    };
    this.documentStatus = null;
    this.uploadStatus = null;
    this.step = 1;
  }

}
